/**
 * Resolve a public asset path against Vite's configured base URL.
 *
 * In production (base = '/'), this is a no-op: '/foo' stays '/foo'.
 * On dev-web preview (base = '/dev/landingram-frontend/main/'),
 * '/foo' becomes '/dev/landingram-frontend/main/foo'.
 *
 * Usage:
 *   <img src={assetUrl('/_assets/bricklink.svg')} />
 */
const base = import.meta.env.BASE_URL ?? '/';
const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;

export function assetUrl(path: string): string {
  // Already absolute URL (https://, data:, blob:, etc.) — return as-is
  if (/^(?:https?:|data:|blob:)/.test(path)) return path;

  // Strip leading slash so we can prepend the base cleanly
  const clean = path.startsWith('/') ? path.slice(1) : path;
  return `${normalizedBase}/${clean}`;
}
